import React from 'react'
import {
  MatchedSearchableItem,
  SearchableItem,
  SearchableEntity
} from './SelectEntitiesForm.types'

export type SelectEntitiesModalDataContextType = {
  entities: SearchableEntity[]
}

export const SelectEntitiesModalDataContext =
  React.createContext<SelectEntitiesModalDataContextType>(
    null as unknown as SelectEntitiesModalDataContextType
  )

export type SelectEntitiesModalQueryContextType = {
  query: string
  items: MatchedSearchableItem[]
  setQuery: (value: string) => void
}

export const SelectEntitiesModalQueryContext =
  React.createContext<SelectEntitiesModalQueryContextType>(
    null as unknown as SelectEntitiesModalQueryContextType
  )

export type SelectedResourcesContextType = {
  selectedIds: Set<SearchableItem['id']>
  setSelectedIds: (ids: SelectedResourcesContextType['selectedIds']) => void
}

export const SelectedEntitiesContext =
  React.createContext<SelectedResourcesContextType>(
    null as unknown as SelectedResourcesContextType
  )
